export default __webpack_public_path__ + "static/17-37fc2603e005f4278ee25f7dd10d8900.webp";